import { memo } from 'react';
import { useTheme } from '@Sage/hoi-poi-ui';
import TruncatedTextPopover from 'components/TruncatedTextPopover';
import { BaseReactCell } from '@Sage/ssm-web5';

import './styles.scss';

const TextPopoverCell = memo(({ value, ...props }) => {
    const theme = useTheme();
    return (
        <BaseReactCell data={value} {...props}>
            <div className="fm-text-popover-cell">
                <TruncatedTextPopover color={theme.colors.utility.textPrimary}>
                    {value || '-'}
                </TruncatedTextPopover>
            </div>
        </BaseReactCell>
    );
});

export default TextPopoverCell;
